import i18next, { TOptions } from 'i18next'

export const translate = (key: string, options: TOptions = {}, fallbackString?: string) => {
  if (i18next.exists(key, options)) {
    return i18next.t<string>(key, options)
  } else {
    console.warn(`Translation does not exist: '${key}'`)
    return fallbackString || `[*] Translation '${key}' does not exist`
  }
}
